import { forwardRef, useContext, useEffect, useImperativeHandle, useState } from "react";
import { config } from "../constants/config";
import UserContext from "../contexts/UserContext";
import { Link } from "react-router-dom";
import { textes } from "../constants/textes";

const SideBar2 = forwardRef((props, ref) => {
    const { user } = useContext(UserContext);
    const [path, setPath] = useState(window.location.pathname);
    // const [isload, setisload] = useState(false);

    const currentdate = new Date()
        .toLocaleDateString("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        })
        .split("/")
        .reverse()
        .join("-");

    const init = async () => {
    }


    useImperativeHandle(ref, () => ({
        async childFunction() {
            // console.log("react");
            // await init();
            // console.log("nb intervention", nbintervention);
            // await getCount();
            // console.log("nb intervention", nbintervention);
        }

    }));

    // comportements
    useEffect(() => {

    }, []);

    // affichages
    return (
        <ul className={props.styl} id="accordionSidebar" style={{ overflowY: "scroll", height: "100%", overflowX: "hidden", scrollbarColor: "#0b5274", scrollbarWidth: "thin" }}>

            {/* <!-- Sidebar - Brand --> */}
            <a className="sidebar-brand d-flex align-items-center justify-content-center" href="/">
                <div className="sidebar-brand-icon rotate-n-15">
                    <i className="fas fa-laugh-wink"></i>
                </div>
                <div className="sidebar-brand-text mx-3" style={{ fontSize: 14 }}>{textes.fr.appname}</div>
                {/* <div className="sidebar-brand-text mx-3">DPS-ADMIN</div> */}
            </a>

            {/* <!-- Divider --> */}
            <hr className="sidebar-divider my-0" />

            <CustomLink
                // liclass={'nav-item'} 
                liclass={path === '/' ? 'nav-item active' : 'nav-item'}
                to="/" icon="fas fa-fw fa-tachometer-alt"
                linkclass="nav-link"
                label={textes.fr.dashbordlabel}
                onClick={() => {
                    setPath(window.location.pathname);
                }}
            />

            {(user?.isFullAction || user?.isAdminAction) && <CustomLink
                // liclass={'nav-item'} 
                liclass={(path === '/revendeurs' || path === '/revendeur') ? 'nav-item active' : 'nav-item'}
                to="/revendeurs" icon="fas fa-fw fa-users"
                linkclass="nav-link"
                label="Revendeurs"
                onClick={() => {
                    setPath(window.location.pathname);
                }}
            />}

            {(user?.isFullAction || user?.isAdminAction) && <CustomLink
                // liclass={'nav-item'} 
                liclass={(path === '/abonnements' || path === '/abonnement' || path === '/tabonnement') ? 'nav-item active' : 'nav-item'}
                to="/abonnements" icon="fas fa-fw fa-gift"
                linkclass="nav-link"
                label={textes.fr.abonnementslabel}
                onClick={() => {
                    setPath(window.location.pathname);
                }}
            />}

            {(!user?.isFullAction && !user?.isAdminAction) && <CustomLink
                // liclass={'nav-item'} 
                liclass={(path === '/my-souscriptions' || path === '/sous-abonnement') ? 'nav-item active' : 'nav-item'}
                to="/my-souscriptions" icon="fas fa-fw fa-gift"
                linkclass="nav-link"
                label="Mes Abonnements"
                onClick={() => {
                    setPath(window.location.pathname);
                }}
            />}

            {(user?.isFullAction || user?.isAdminAction || user?.isGererSite) && <CustomLink
                // liclass={'nav-item'} 
                liclass={(path === '/sites' || path === '/site') ? 'nav-item active' : 'nav-item'}
                to="/sites" icon="fas fa-fw fa-building"
                linkclass="nav-link"
                label={textes.fr.siteslabel}
                onClick={() => {
                    setPath(window.location.pathname);
                }}
            />}

            {(user?.isFullAction || user?.isAdminAction || user?.isGererHotspot) && <CustomLink
                // liclass={'nav-item'} 
                liclass={(path === '/hotspots' || path === '/hotspot') ? 'nav-item active' : 'nav-item'}
                to="/hotspots" icon="fas fa-fw fa-server"
                linkclass="nav-link"
                label={textes.fr.hotspotslabel}
                onClick={() => {
                    setPath(window.location.pathname);
                }}
            />}

            {(user?.isFullAction || user?.isAdminAction || user?.isGererForfait) && <CustomLink
                // liclass={'nav-item'} 
                liclass={(path === '/forfaits' || path === '/forfait' || path === '/tforfait') ? 'nav-item active' : 'nav-item'}
                to="/forfaits" icon="fas fa-fw fa-gift"
                linkclass="nav-link"
                label={textes.fr.forfaitslabel}
                onClick={() => {
                    setPath(window.location.pathname);
                }}
            />}

            {(user?.isFullAction || user?.isAdminAction || user?.isGererSouscription) && <CustomLink
                // liclass={'nav-item'} 
                liclass={(path === '/souscriptions' || path === '/sous-forfait' || path === '/sous-abonnement') ? 'nav-item active' : 'nav-item'}
                to="/souscriptions" icon="fas fa-fw fa-gifts"
                linkclass="nav-link"
                label={textes.fr.souscriptionslabel}
                onClick={() => {
                    setPath(window.location.pathname);
                }}
            />}

            {(user?.isFullAction || user?.isAdminAction || user?.isGererTransaction) && <CustomLink
                // liclass={'nav-item'} 
                liclass={(path === '/transactions' || path === '/transaction') ? 'nav-item active' : 'nav-item'}
                to="/transactions" icon="fas fa-fw fa-money-bill"
                linkclass="nav-link"
                label={textes.fr.transactionslabel}
                onClick={() => {
                    setPath(window.location.pathname);
                }}
            />}

            {(user?.isFullAction || user?.isAdminAction || user?.isGererPublicite) && <CustomLink
                // liclass={'nav-item'} 
                liclass={(path === '/pubs' || path === '/pub') ? 'nav-item active' : 'nav-item'}
                to="/pubs" icon="fas fa-fw fa-newspaper"
                linkclass="nav-link"
                label={textes.fr.publiciteslabel}
                onClick={() => {
                    setPath(window.location.pathname);
                }}
            />}

            {(user?.isFullAction || user?.isAdminAction || user?.isGererCompteVPN) && <CustomLink
                // liclass={'nav-item'} 
                liclass={(path === '/vpns' || path === '/vpn') ? 'nav-item active' : 'nav-item'}
                to="/vpns" icon="fas fa-fw fa-network-wired"
                linkclass="nav-link"
                label={textes.fr.comptevpnslabel}
                onClick={() => {
                    setPath(window.location.pathname);
                }}
            />}

            {(user?.isFullAction || user?.isAdminAction || user?.isGererDemanderetrait) && <CustomLink
                // liclass={'nav-item'} 
                liclass={(path === '/demandes-retrait' || path === '/demande-retrait') ? 'nav-item active' : 'nav-item'}
                to="/demandes-retrait" icon="fas fa-fw fa-money-bill-wave"
                linkclass="nav-link"
                label={textes.fr.dmretratislabel}
                onClick={() => {
                    setPath(window.location.pathname);
                }}
            />}





            {/* =============================== securite ============================= */}
            {(user?.isFullAction || user?.isGererIncrement) &&
                <CustomLink
                    liclass={(path === '/increments' || path.indexOf("increment") > -1) ? 'nav-item active' : 'nav-item'}
                    to="/increments"
                    icon="fas fa-fw fa-list-ol"
                    linkclass="nav-link"
                    label={textes.fr.incrementslabel}
                    onClick={() => {
                        setPath(window.location.pathname);
                    }}
                />
            }
            {(user?.isFullAction || user?.isGererDomaine) &&
                <CustomLink
                    liclass={(path === '/domains' || path.indexOf("domain") > -1) ? 'nav-item active' : 'nav-item'}
                    to="/domains"
                    icon="fas fa-fw fa-list"
                    linkclass="nav-link"
                    label={textes.fr.domainslabel}
                    onClick={() => {
                        setPath(window.location.pathname);
                    }}
                />
            }
            {(user?.isFullAction || user?.isGererClient) &&
                <CustomLink
                    liclass={(path === '/clients' || path.indexOf("client") > -1) ? 'nav-item active' : 'nav-item'}
                    to="/clients"
                    icon="fas fa-fw fa-building"
                    linkclass="nav-link"
                    label={textes.fr.customerslabel}
                    onClick={() => {
                        setPath(window.location.pathname);
                    }}
                />
            }
            {(user?.isFullAction || user?.isGererLicence) &&
                <CustomLink
                    liclass={(path === '/licences' || path.indexOf("licence") > -1) ? 'nav-item active' : 'nav-item'}
                    to="/licences"
                    icon="fas fa-fw fa-balance-scale"
                    linkclass="nav-link"
                    label={textes.fr.licenceslabel}
                    onClick={() => {
                        setPath(window.location.pathname);
                    }}
                />
            }
            {(user?.isFullAction || user?.isGererDroit) &&
                <CustomLink
                    liclass={(path === '/rules' || path.indexOf("rule") > -1) ? 'nav-item active' : 'nav-item'}
                    to="/rules"
                    icon="fas fa-fw fa-balance-scale"
                    linkclass="nav-link"
                    label={textes.fr.ruleslabel}
                    onClick={() => {
                        setPath(window.location.pathname);
                    }}
                />
            }
            {(user?.isFullAction || user?.isGererEspTrav) &&
                <CustomLink
                    liclass={(path === '/workspaces' || path.indexOf("workspace") > -1) ? 'nav-item active' : 'nav-item'}
                    to="/workspaces"
                    icon="fas fa-fw fa-users"
                    linkclass="nav-link"
                    label={textes.fr.workspaceslabel}
                    onClick={() => {
                        setPath(window.location.pathname);
                    }}
                />
            }
            {(user?.isFullAction || user?.isAdminAction || user?.isGererProfil) &&
                <CustomLink
                    liclass={(path === '/profiles' || path.indexOf("profile") > -1) ? 'nav-item active' : 'nav-item'}
                    to="/profiles"
                    icon="fas fa-fw fa-address-card"
                    linkclass="nav-link"
                    label={textes.fr.profilslabel}
                    onClick={() => {
                        setPath(window.location.pathname);
                    }}
                />
            }
            {(user?.isFullAction  || user?.isAdminAction || user?.isGererUtilisateur || user?.isGererCompte) &&
                <CustomLink
                    liclass={(path === '/accounts' || path.indexOf("account") > -1) ? 'nav-item active' : 'nav-item'}
                    to="/accounts"
                    icon="fas fa-fw fa-user"
                    linkclass="nav-link"
                    label={textes.fr.accountslabel}
                    onClick={() => {
                        setPath(window.location.pathname);
                    }}
                />
            }
            {(user?.isFullAction || user?.isAdminAction || user?.isGererUtilisateur) &&
                <CustomLink
                    liclass={(path === '/users' || path.indexOf("user") > -1) ? 'nav-item active' : 'nav-item'}
                    to="/users"
                    icon="fas fa-fw fa-users"
                    linkclass="nav-link"
                    label={textes.fr.userslabel}
                    onClick={() => {
                        setPath(window.location.pathname);
                    }}
                />
            }
            {(user?.isFullAction || user?.isAdminAction || user?.isGererConnexion) &&
                <CustomLink
                    liclass={(path === '/connexions' || path.indexOf("connexion") > -1) ? 'nav-item active' : 'nav-item'}
                    to="/connexions"
                    icon="fas fa-fw fa-sign"
                    linkclass="nav-link"
                    label={textes.fr.connexionslabel}
                    onClick={() => {
                        setPath(window.location.pathname);
                    }}
                />
            }
            {(user?.isFullAction || user?.isAdminAction || user?.isGererMouchard) &&
                <CustomLink
                    liclass={(path === '/activites' || path.indexOf("activite") > -1) ? 'nav-item active' : 'nav-item'}
                    to="/activites"
                    icon="fas fa-fw fa-eye"
                    linkclass="nav-link"
                    label={textes.fr.activitieslabel}
                    onClick={() => {
                        setPath(window.location.pathname);
                    }}
                />
            }


        </ul>
    );

});

function CustomLink({ linkclass, liclass, to, icon, label, state, nb, ...props }) {
    return (
        <li className={liclass} {...props}>
            <Link className={linkclass} to={to} state={state}>
                <i className={icon}></i> <span> {label} </span>
                {(nb !== null && nb > 0) && <span className="badge badge-square rounded badge-light" style={{ fontSize: 12, position: "absolute", right: 18, top: "auto", bottom: "auto", marginTop: 3 }}>{nb}</span>}
            </Link>
        </li>
    )
}
export default SideBar2;